<template>
  <div class="header">
    <div class="header-left">
      <h1>IITC工信人才岗位能力评价</h1>
    </div>
    <div class="header-center">
      <h1>{{ examManageName }}</h1>
    </div>
    <div class="header-right">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-info">
          <img :src="userAvatar" alt="" />
          <!-- <el-avatar :src="userAvatar"></el-avatar> -->
          <span> 欢迎您，{{ userInfo.realName }}</span>
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="info">个人信息</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog
      class="dialog"
      title=""
      :visible.sync="dialogVisible"
      width="400px"
    >
      <div class="flex-center">
        <img :src="userAvatar" alt="" />
      </div>
      <p>学员姓名: {{ userInfo.realName }}</p>
      <p>学员ID: {{ userInfo.userId }}</p>
      <p>身份证号: {{ userInfo.idCard }}</p>
      <p>准考证号: {{ userInfo.examCode }}</p>

      <div class="flex-center">
        <el-button type="warning" @click="handleLogout">退出登录</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      userInfo: this.$store.state.user.userInfo,
      examManageName: this.$store.state.examManage.examManageName,
      // userAvatar: "https://picsum.photos/id/1005/200/200",
      userAvatar: require("@/assets/avatar.png"),
      env: process.env.VUE_APP_ENV,
      apiBaseUrl: process.env.VUE_APP_BASE_API,
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {
    handleCommand(command) {
      if (command === "logout") {
        this.handleLogout();
      } else if (command === "info") {
        this.dialogVisible = true;
      }
    },
    async handleLogout() {
      this.$confirm("确认退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          await this.$store.dispatch("user/logout");
          this.$message.success("退出登录成功");
          this.$router.push("/?p=" + localStorage.getItem("EXAM_CODE"));
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.header {
  padding: 8px 20px;
  width: calc(100% - 40px);
  background-color: #373d41;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* .header-left  */
h1 {
  margin: 0;
  font-size: 20px;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: white;
}

.user-info .el-avatar {
  margin-right: 10px;
}

.el-menu-vertical-demo {
  background-color: #333744;
  border-right: none;
}

.el-menu-item {
  color: #b3bcc5;
}

.el-menu-item.is-active {
  color: #fff;
  background-color: #1890ff;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.dialog img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
</style>
